import config from '../../config';
import { requests } from '../../utils/DataUtil';
import { findNewParticipantsMock } from './mocks/findNewParticipants';

const baseURL = `${config.pronvest.api.url}Participants`;
const isMocked = import.meta.env.VITE_MOCK === 'true';

export const integratedTransitionApi = {
  getManagedAccounts: (distributorId, planSponsorId) => {
    const body = { distributorId };
    if (planSponsorId) body.planSponsorId = planSponsorId;
    return requests.POST(`${baseURL}/GetManagedAccountParticipantIDs`, body);
  },

  findNewParticipants: (data) => {
    if (isMocked) {
      return Promise.resolve({ json: () => Promise.resolve(findNewParticipantsMock), status: 200, ok: true });
    }
    return requests.POST(`${baseURL}/NewParticipantMatch`, data);
  },

  submitTransition: (data) =>
    requests.POST(`${baseURL}/TransitionToIntegrated`, data),
};
